import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MailAccount } from '../../services/mail.service';
import { ComposeDraft, MailComposeComponent } from '../mail-compose/mail-compose.component';

export interface TemplateMailComposeDialogData {
  account: MailAccount | null;
  draft: ComposeDraft;
}

@Component({
  selector: 'vex-template-mail-compose-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MailComposeComponent],
  template: `
    <div class="template-compose-dialog">
      <vex-mail-compose
        [account]="data.account"
        [draft]="data.draft"
        [maximized]="maximized"
        [minimized]="minimized"
        mode="compose"
        (close)="close()"
        (maximizeChange)="maximized = $event"
        (minimizeChange)="minimized = $event"></vex-mail-compose>
    </div>
  `,
  styles: [`
    .template-compose-dialog {
      width: fit-content;
      max-width: min(720px, calc(100vw - 24px));
      display: flex;
      justify-content: center;
      align-items: stretch;
      margin: 0 auto;
    }

    @media (max-width: 768px) {
      .template-compose-dialog {
        width: 100%;
        max-width: calc(100vw - 12px);
      }
    }
  `]
})
export class TemplateMailComposeDialogComponent {
  minimized = false;
  maximized = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TemplateMailComposeDialogData,
    private dialogRef: MatDialogRef<TemplateMailComposeDialogComponent>
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
